import { render } from "./GenerateLicenseModal.vue?vue&type=template&id=01f3aed9&ts=true"
import script from "./GenerateLicenseModal.vue?vue&type=script&lang=ts"
export * from "./GenerateLicenseModal.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__